<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div class="page-name color-71aa3f">
                        {{customerArr[0].first_name}} <span class="badge badge-info">{{ formatString(customerArr[0].status)}}</span>
                    </div>
                    <div class="red-box clickable-div" v-if="lienMessage != ''">
                        <a href="javascript:void(0)" @click="navigateLien()" class="no-style" v-html="lienMessage"></a>
                    </div>

                    <button type="submit" :class="'btn general-button btn-primary' + (lienMessage != '' ? ' custom-class-margin' : '')" v-on:click.prevent="backShowCustomer">Back</button>
                </div>
                <div class="admin-page-content">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <div class="forms-container">
                                <h3 class="color-71aa3f">Customer Information </h3>
                                <b-list-group class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <strong>Customer Name : </strong>
                                                <span class="">{{customerArr[0].first_name}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <strong>BillCusId : </strong>
                                                <span class="">{{customerArr[0].billcusid}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <strong>Credit Limit : </strong>
                                                <span class="">{{formatAmount(customerArr[0].amt_cr_limit)}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <strong>Credit Status : </strong>
                                                <span class="">{{customerArr[0].credit_status}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <strong>Auto Bulk Oil : </strong>
                                                <span class="">{{customerArr[0].auto_bulk_oil}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                </b-list-group>
                                <b-list-group class="col-xl-6 col-lg-6 col-md-6 col-sm-12 pr-0">
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <strong>Total Due Amount : </strong>
                                                <span class="">{{formatAmount(customerArr[0].total_due_amount)}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <strong>Last Paid Date : </strong>
                                                <span class="">{{formatDate(customerArr[0].date_payment)}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <strong>Dunning Notice Activate : </strong>
                                                <span class="">{{formatString(customerArr[0].dunning_notice)}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <strong>VIP : </strong>
                                                <span class="">{{customerArr[0].vip}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                </b-list-group>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <b-button class="pull-right" v-b-toggle.collapse1 variant="link">View More...</b-button>
                                    <div class="clearfix"></div>
                                    <b-collapse id="collapse1" class="mt-2 mb-3">
                                        <div class="row">
                                            <b-list-group class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>CusId : </strong>
                                                            <span class="">{{customerArr[0].cusid}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Description : </strong>
                                                            <span class="">{{customerArr[0].description}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Last Invoice Date : </strong>
                                                            <span class="">{{formatDate(customerArr[0].date_invoice)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Last Invoice Amount : </strong>
                                                            <span class="">{{formatAmount(customerArr[0].amt_invoice)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Last Paid Amount : </strong>
                                                            <span class="">{{ formatAmount(customerArr[0].amt_payment) }}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Past Due Term : </strong>
                                                            <span class="">{{ customerArr[0].due_days }} Days</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Credit Limit On Invoice : </strong>
                                                            <span class="">{{formatAmount(customerArr[0].amt_cr_limit_invoice)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Current Due : </strong>
                                                            <span class="">{{formatAmount(customerArr[0].amt_aged0)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Due Over 1 To 30 Days : </strong>
                                                            <span class="">{{formatAmount(customerArr[0].amt_aged1to30)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Due Over 31 To 60 Days : </strong>
                                                            <span class="">{{formatAmount(customerArr[0].amt_aged31to60)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Due Over 61 To 90 Days : </strong>
                                                            <span class="">{{formatAmount(customerArr[0].amt_aged61to90)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Due Over 90 Days : </strong>
                                                            <span class="">{{formatAmount(customerArr[0].amt_aged_over90)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Amount Balance Open : </strong>
                                                            <span class="">{{formatAmount(customerArr[0].amt_bal_open)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                            </b-list-group>
                                            <b-list-group class="col-xl-6 col-lg-6 col-md-6 col-sm-12 pr-0">
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Customer Type : </strong>
                                                            <span class="">{{formatString(customerArr[0].customer_type)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Registration Age : </strong>
                                                            <span class="">{{customerArr[0].reg_age_days}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <h4 class="color-23727b">Contact</h4>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Collector : </strong>
                                                            <span class="">{{customerArr[0].user_first_name}} {{customerArr[0].user_last_name}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Contact Name : </strong>
                                                            <span class="">{{customerArr[0].c_name}} {{customerArr[0].c_last_name}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Fax : </strong>
                                                            <span class="">{{customerArr[0].c_fax}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Job Title : </strong>
                                                            <span class="">{{customerArr[0].c_job_title}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Business Unit : </strong>
                                                            <span class="">{{customerArr[0].bu_home}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Description : </strong>
                                                            <span class="">{{customerArr[0].c_description}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Email : </strong>
                                                            <span class="">{{customerArr[0].contact_email}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Secondary Email : </strong>
                                                            <span class="">{{customerArr[0].contact_email2}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Phone : </strong>
                                                            <span class="">{{mobilenumber(mobilenumber(customerArr[0].contact_phone,3,'-'),7,'-')}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Secondary Phone : </strong>
                                                            <span class="">{{mobilenumber(mobilenumber(customerArr[0].contact_phone2,3,'-'),7,'-')}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                            </b-list-group>
                                        </div>
                                    </b-collapse>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <div class="forms-container">
                                <h3 class="color-71aa3f">Settings</h3>
                                <div class="row no-margin ml-0 mr-0">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide paddingleft0 pr-0">
                                        <div class="alert alert-success" id="alertSuccess">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span>Collector Updated Successfully</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide paddingleft0 pr-0">
                                        <div class="alert alert-danger" id="alertError">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span id="errorMsg" class="error"></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 paddingleft0 ">
                                        <label class="form-label" for="user_id"><strong>Collector</strong></label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 paddingleft0 pr-0">
                                        <v-select id="collector" v-model="user_id" @change="userChangedValue" name="user_id" label="text" :filterable="false" :options="usersArr" @search="onSearchUser" v-validate="'required'">
                                            <template slot="no-options">
                                                type to search Collector...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select><br/>
                                        <span v-show="errors.has('user_id')" class="help is-danger" v-if="errors.has('user_id')"><font color="red">Collector is Required</font></span>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 paddingleft0">
                                        <label class="form-label " for="user_id"><strong>Dunning Notice Status</strong></label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 paddingleft0 form-label pr-0">
                                        <!--<v-select
                                            name="dunningNotice"
                                            v-model="dunningNotice"
                                            id="status" label="text"
                                            :options="dunningNoticeArr"
                                            :required="true"
                                            :value="dunningNotice"
                                            v-validate="'required'"
                                            ></v-select><br/>-->
                                        <b-form-radio-group v-model="dunningNotice"
                                                            :options="dunningNoticeArr"
                                                            name="dunningNotice">
                                        </b-form-radio-group>
                                        <!--{{dunningNotice}}-->
                                        <span v-show="errors.has('dunningNotice')" class="help is-danger" v-if="errors.has('dunningNotice')"><font color="red">Dunning Notice Status is Required.</font></span>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 paddingleft0 pr-0">
                                        <input id="addCaseBtn" type="submit" value="Update" class="btn general-button btn-primary" v-on:click.prevent="updateCollector()">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-show="canUploadDocuments" class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-2">
                            <div class="forms-container">
                                <h3 class="color-71aa3f">Upload Documents</h3>
                                <div class="row no-margin ml-0 mr-0">
                                    <div class="col-xs-12 paddingleft0 w-100">
                                        <label class="control-label mb-0" for="documents">Allowed file types: .jpg, .jpeg, .png, .pdf, .zip (10 documents per customer are allowed).
                                        </label>
                                        <div>
                                            <vue-dropzone class="mb-1" id="documentDropzone" :options="dropzoneOptions"
                                                :destroyDropzone="false"
                                                ref="documentDropzone"
                                                :headers="dropzoneOptions.headers"
                                                @vdropzone-success="storeDocument"
                                                @vdropzone-removed-file="removedSelectedFile"
                                                @vdropzone-file-added="checkFileSize">
                                            </vue-dropzone>
                                            <div v-if="fileErrorMsg" class="field-error">{{ fileErrorMsg }}</div>
                                        </div>
                                        <div class="text-right col paddingleft0 pr-0 mt-2">
                                            <button class="btn general-button btn-primary" type="button" v-on:click="uploadDocs()">Upload</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-2 dropzone-previews">
                            <div class="forms-container">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <h3 class="color-71aa3f m-0">Uploaded Documents</h3>
                                    <button v-if="dropZonePreviewFiles.length > 0" class="btn general-button btn-primary mt-1" v-on:click="downloadAllFiles()">Download All (ZIP)</button>
                                </div>
                                <div class="row no-margin ml-0 mr-0">
                                    <div v-if="!dropZonePreviewFiles.length" class="col-xs-12 paddingleft0 w-100">
                                        No Documents Uploaded
                                    </div>
                                    <div v-else class="col-xs-12 paddingleft0 w-100">
                                        <template v-for="(uFile, fKey) in dropZonePreviewFiles">
                                            <div v-bind:key="'fileDiv' + fKey" class="attachment-list">
                                                <div>
                                                    <i v-if="uFile.extension == 'pdf'" class="fa fa-file-pdf-o"></i>
                                                    <i v-else-if="uFile.extension == 'doc' ||
                                                        uFile.extension == 'docs' ||
                                                        uFile.extension == 'docx'" class="fa fa-file-text-o"></i>
                                                    <i v-else-if="uFile.extension == 'jpg' ||
                                                        uFile.extension == 'png' ||
                                                        uFile.extension == 'jpeg'" class="fa fa-file-image-o"></i>
                                                    <i v-else-if="uFile.extension == 'zip'" class="fa fa-file-zip-o"></i>
                                                    <a title="View File" href="javascript:void(0)" v-on:click="
                                                        goToGenerateFilePath(uFile.filePath, 'single')"
                                                        v-bind:key="'fileName' + fKey">
                                                        {{ uFile["file_name"] }}
                                                    </a>
                                                </div>
                                                <button v-show="canUploadDocuments" class="outline-0 border-0" title="Remove File" type="button" v-bind:key="'cancelBtn' + fKey" v-on:click="
                                                    removeFileFromServer(uFile['file_name'], fKey, uFile.filePath)">
                                                    <i class="fa fa-remove" style="color: #E4441B;"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-2">
                            <div class="forms-container" >
                                <h3 class="color-71aa3f">Card Information </h3>

                                <div v-if="cardDetailArr[0] && cardDetailArr.length > 0">
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 paddingleft0 pr-0">
                                        <v-select
                                            name="credit_card"
                                            v-model="credit_card"
                                            id="direction" label="card_number"
                                            :options="cardDetailArr"
                                            placeholder="Card Number"
                                            :bg-color="'#EF9A9A'"
                                        >
                                        
                                        <template slot="option" slot-scope="option">
                                            <div
                                                :class="{
                                                'highlighted': isExpiringSoon(option.expiry_date)
                                                }"
                                                class="v-select-option"
                                            >
                                             {{ option.card_number }}
                                            </div>
                                        </template>
                                    </v-select>
                                    </div>
                                    <router-link title='Edit Credit Card' class="btn edit-btn-vvg waves-effect" v-bind:to="{name: 'EditCard',params:{id:credit_card.id,from:$route.params.id}}"><i class="fa fa-pencil-square-o"></i></router-link>
                                    <a href="javascript:void(0)" title='Add Credit Card' class="btn add-btn-vvg waves-effect" v-on:click.prevent="addCustomerCard()"><i class="fa fa-plus"></i></a>
                                    <b-list-group class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-2">
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                    <strong> Card# : </strong>
                                                    <span class="">{{maskCardNumber(selectedCard.card_number)}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                    <strong> Card On File : </strong>
                                                    <span class="">{{selectedCard.card_on_file}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                        
                                    </b-list-group>
                                    <b-list-group class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-2">
                                        <b-list-group-item id="expiryWarning">
                                            <div class="row">
                                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                    <strong>Expiry Date : </strong>
                                                    <span class="">{{selectedCard.expiry_date}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                    <strong>Email : </strong>
                                                    <span class="">{{selectedCard.email}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                    </b-list-group>

                                    <b-list-group class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-2">
                                        <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                            <strong>Process Date:</strong>
                                            <v-select
                                                name="process_date"
                                                v-model="selectedCard.process_date"
                                                id="direction"
                                                label="text"
                                                :options="daysInMonth"
                                                placeholder="Select Day"
                                            ></v-select>
                                            </div>
                                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 custom-margin">
                                            <input
                                                id="addCardBtn"
                                                type="button"
                                                value="Update"
                                                class="btn general-button btn-primary"
                                                v-if="canAddCard"
                                                v-on:click.prevent="addProcessDate(selectedCard.process_date,selectedCard.id)"
                                            >
                                            </div>
                                        </div>
                                        </b-list-group-item>
                                    </b-list-group>
                                    <b-list-group class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-2">
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                    <strong>Notes : </strong>
                                                    <span class="">{{selectedCard.notes}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                    </b-list-group>
                                </div>
                                <div v-else class="col-lg-12 col-md-12 col-sm-12 col-xs-12 paddingleft0 pr-0 mt-2">
                                    <input id="addCardBtn" type="submit" value="Add Card" class="btn general-button btn-primary" v-on:click.prevent="addCustomerCard()">
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-2">
                            <div class="forms-container">
                                <h3 class="color-71aa3f">Cab Card</h3>

                                <!-- Edit/View Carb Card Section -->
                                <div v-show="has_carb_card">
                                    <a v-if="!is_carb_add" href="javascript:void(0)" title="Edit Card Card" 
                                    class="btn add-btn-vvg waves-effect btn-primary" 
                                    @click.prevent="is_carb_add = true">
                                        <i class="fa fa-pencil"> Edit</i>
                                    </a>

                                    <b-list-group class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-2">
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                                    <strong>Cab Card:</strong>
                                                    <input id="carb_card" name="carb_card" type="text" class="form-control" 
                                                        v-model="carb_card" v-validate="'required'" 
                                                        placeholder="Card#" :disabled="!is_carb_add">
                                                    <div class="requiredstar">*</div>
                                                    <span v-show="errors.has('carb_card')" class="help is-danger">
                                                        <font color="red">Card is Required</font>
                                                    </span>
                                                </div>
                                            </div>
                                        </b-list-group-item>

                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                                    <strong>Expiration Date:</strong>
                                                    <input type="date" id="carb_card_expiry" v-validate="'required'" 
                                                        name="carb_card_expiry" class="form-control" 
                                                        placeholder="Enter Date in MM/DD/YYYY" 
                                                        v-model="carb_card_expiry" :disabled="!is_carb_add">
                                                    <div class="requiredstar">*</div>
                                                    <span v-show="errors.has('carb_card_expiry')" class="help is-danger">
                                                        <font color="red">Card's Expiration Date is Required</font>
                                                    </span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                    </b-list-group>

                                    <!-- Save & Cancel Buttons -->
                                    <div v-if="is_carb_add" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 paddingleft0 pr-0 mt-2">
                                        <button id="saveCardBtn" class="btn general-button btn-primary" @click.prevent="saveCarbCard">
                                            Save
                                        </button>
                                        <button id="cancel" class="btn general-button btn-secondary" @click="cancelCarbCard">
                                            Cancel
                                        </button>
                                    </div>
                                </div>

                                <!-- Add Carb Card Button -->
                                <div v-show="!has_carb_card" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 paddingleft0 pr-0 mt-2">
                                    <button id="addCardBtn" class="btn general-button btn-primary" @click.prevent="addCarbCard">
                                        Add Cab Card
                                    </button>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <app-contact v-show="canAccessContactModule" :contactPageData='contactPage'></app-contact>
                <app-call v-show="canAccessCallModule" :callPageData='callPage' :viewAllNotes="true"></app-call>
                <app-task v-show="canAccessTaskModule" :taskPageData='taskPage'></app-task>
                <app-followup v-show="canAccessFollowupModule" :followupPageData='followupPageData'></app-followup>
                <app-resale v-show="canAccessResaleModule" :resalePageData='resalePage'></app-resale>
                <app-case v-show="canAccessCaseModule" :casePageData='casePage'></app-case>
                <app-lien v-show="canAccessLienModule" :LienPageData='lienPage' class="lien-mod-class"></app-lien>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>
<script>
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import {list_taskUrl} from '../../config';
    import FrontFooter from '@/components/partials/FrontFooter';
    import ListContactComponent from "@/components/contact/ListContactComponent";
    import ListTasksComponent from "@/components/task/ListTasksComponent";
    import ListReshaleComponent from "@/components/resale/ListReshaleComponent";
    import ListCallsComponent from "@/components/callsAndEmails/ListCallsComponent";
    import CaseListComponent from "@/components/cases/CaseListComponent";
    import ListLienComponent from "@/components/lien/ListLienComponent";
    import ListFollowupComponent from "@/components/followup/ListFollowupComponent";
    import VeeValidate from 'vee-validate';
    import EventBus from '../event-bus';
    import swal from 'sweetalert2/dist/sweetalert2.js';
    const Swal = require('sweetalert2');
    Vue.use(VeeValidate);
    import SessioMixin from '../../mixins/sessionmixin';
    export default {
        name: 'CustomerView',
        mixins: [SessioMixin],
        components: {
            'app-resale': ListReshaleComponent,
            'app-task': ListTasksComponent,
            'app-call': ListCallsComponent,
            'app-case': CaseListComponent,
            'app-contact': ListContactComponent,
            'app-footer': FrontFooter,
            'app-lien':ListLienComponent,
            'app-followup':ListFollowupComponent
        },
        data() {
            return{
                taskPage: {
                    pageTitle: this.LabelName('customertask'),
                    perPage: 5,
                    cus_id: 0,
                    is_part: 1,
                },
                resalePage: {
                    pageTitle: 'Customer Resale',
                    perPage: 5,
                    cus_id: 0,
                    is_part: 1,
                    sv_tax_id: '',
                    pt_tax_id: '',
                    is_cust_detail: true,
                },
                lienPage: {
                    pageTitle: 'Lien List',
                    perPage: 25,
                    cus_id: 0,
                    is_part: 0,
                    is_cust_detail: true,
                },
                callPage: {
                    pageTitle: 'Customer '+ this.LabelName('callsemaillabel'),
                    perPage: 5,
                    cus_id: 0,
                    is_part: 1,
                },
                casePage: {
                    pageTitle: 'Customer Cases',
                    perPage: 5,
                    cus_id: 0,
                    is_part: 1,
                },
                contactPage: {
                    pageTitle: 'Customer Contacts',
                    perPage: 2,
                    cus_id: 0,
                    is_part: 1,
                },
                followupPageData: {
                    pageTitle: 'Follow Up',
                    perPage: 5,
                    cus_id: 0,
                    is_part: 1,
                },
                cardDetailArr:[],
                card_number:'',
                credit_card:'',
                selectedCard:{},
                messageCase: 'all',
                loginID: 0,
                permissions: [],
                cantAccessPage: true,
                isLoggedIn: false,
                customerArr: [[]],
                user_id: "",
                cus_id: "",
                dunningNotice: "active",
                dunningNoticeArr: [
                    {
                        value: 'active', text: "Active"
                    },
                    {
                        value: 'inactive', text: "Inactive"
                    }
                ],
                usersArr: [],
                firstLoad: 0,
                columnsCase: [
                    {
                        label: 'Case ID',
                        field: 'id',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "ID", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Collector',
                        field: 'collector_user_full_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Collector", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'CusId',
                        field: 'cusid',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "CusId", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Customer Name',
                        field: 'customer_firstname',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Customer Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Assigned Internal User',
                        field: 'assigned_internal_user',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Assigned Internal User", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Status',
                        field: 'status',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Select Status", // placeholder for filter input
                            filterDropdownItems: ['Open', 'In Progress', 'Resolved', 'Closed'], // dropdown (with selected values) instead of text input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Priority',
                        field: 'priority',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Select Priority", // placeholder for filter input
                            filterDropdownItems: ['Low', 'Normal', 'High'], // dropdown (with selected values) instead of text input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Reported On',
                        field: 'created_at',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "From | To", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        sortable: false,
                        thClass: 'disable-sorting',
                    }

                ],
                rowsCase: [],
                totalRecordsCase: 0,
                serverParamsCase: {
                    columnFilters: {

                    },
                    sort: {
                        field: 'id',
                        type: 'desc',
                    },
                    page: 1,
                    perPage: 5
                },
                canAccessTaskModule:false,
                canAccessFollowupModule:false,
                canAccessCallModule:false,
                canAccessCaseModule:false,
                canAccessLienModule:false,
                canAccessResaleModule:false,
                canAccessContactModule:false,
                dropzoneOptions: {
                    url: process.env.ROOT_API + "/upload-temp-files",
                    method: "POST",
                    maxFilesize: 25.0, //MB
                    maxFiles: 10,
                    thumbnailWidth: 50, // px
                    thumbnailHeight: 50,
                    createImageThumbnails: false,
                    addRemoveLinks: true,
                    duplicateCheck: true,
                    timeout: 180000,
                    acceptedFiles: ".jpg, .jpeg, .png, .pdf, .zip",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dictRemoveFileConfirmation: "Are you sure? You can't revert your action",
                    destroyDropzone: false,
                    dictDefaultMessage:
                        "Drop file here to upload. File upto maximum 25 MB size are allowed.",
                },
                dropZonePreviewFiles: [],
                fileErrorMsg: '',
                files: [],
                removeFileFlag: false,
                countFiles: 0,
                dropzoneInstance: null,
                canUploadDocuments: false,
                lienMessage:'',
                daysInMonth:[],
                canAddCard:false,
                carb_card:'',
                carb_card_expiry:'',
                is_carb_add:false,
                has_carb_card:false,
            }
        },
        watch:{
            countFiles(newValue){
                this.dropzoneInstance.options.maxFiles = 10;
                if (this.dropzoneInstance) {
                    this.dropzoneInstance.options.maxFiles -= newValue;
                }
            },
            'dropzoneInstance.options.maxFiles'() {
                if (this.dropzoneInstance.options.maxFiles < 0) {
                    this.dropzoneInstance.options.maxFiles = 0;
                }
            },
            credit_card(newCard, oldCard) {
                if (newCard) {
                    this.selectedCard = newCard; // Update selected card details
                } else {
                    this.selectedCard = {}; // Reset if no card is selected
                }
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                app.loadCustomer();
                app.contactPage.cus_id = app.casePage.cus_id = app.taskPage.cus_id = app.resalePage.cus_id = app.callPage.cus_id = app.lienPage.cus_id = app.followupPageData.cus_id     = app.$route.params.id;
                app.isLoggedIn = true;
                app.getPermissions();
            }
        },
        mounted: function () {
            $(".removeActive").removeClass('active');
            $("#menucustomers").addClass('active');
            var self = this;
            self.showLoader();
            if (localStorage.getItem("menu_small") == '1') {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            //self.loadCustomer();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginID = userJson.id;
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }

            self.dropzoneInstance = self.$refs.documentDropzone.dropzone;

            const year = new Date().getFullYear();
            const month = new Date().getMonth(); // 0-based, January is 0

            self.daysInMonth = self.getSpecificDays(year, month);

        },
        methods: {
            getLastBusinessDayOfMonth(year, month) {
                const lastDay = new Date(year, month + 1, 0); // Last day of the month
                const lastDayOfWeek = lastDay.getDay();
                
                // Adjust if the last day is a weekend
                if (lastDayOfWeek === 0) { // Sunday
                    return new Date(year, month + 1, -2).getDate(); // Move to Friday
                } else if (lastDayOfWeek === 6) { // Saturday
                    return new Date(year, month + 1, -1).getDate(); // Move to Friday
                }

                return lastDay.getDate(); // If it's a weekday
            },

            getSpecificDays(year, month) {
                const specificDays = [10, 15, 20];
                const lastBusinessDay = this.getLastBusinessDayOfMonth(year, month);

                specificDays.push(lastBusinessDay);

                return specificDays.map(day => {
                    return {
                        value: day,
                        text: `${day}${this.getDaySuffix(day)} of the month`
                    };
                });
            },

            getDaySuffix(day) {
                if (day >= 11 && day <= 13) return "th";
                switch (day % 10) {
                    case 1: return "st";
                    case 2: return "nd";
                    case 3: return "rd";
                    default: return "th";
                }
            },
            isExpiringSoon(expiryDate) {
                const currentDate = new Date();
                const next30Days = new Date();
                next30Days.setDate(currentDate.getDate() + 30);
                var splitDate = expiryDate.split('/');
                if (splitDate[1]){
                    const firstDayOfNextMonth = new Date(splitDate[1], splitDate[0], 1);
                    const newExpiry = new Date(firstDayOfNextMonth - 1);
                    return newExpiry >= currentDate && newExpiry <= next30Days;
                }

                return false;
            },
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        $(".removeActive").removeClass('active');
                        $("#menucustomers").addClass('active');
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_see_customer_view') {
                                        self.cantAccessPage = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_task_list') {
                                        self.canAccessTaskModule = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_followup_list') {
                                        self.canAccessFollowupModule = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_contact_list') {
                                        self.canAccessContactModule = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_calls_list') {
                                        self.canAccessCallModule = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_case_list') {
                                        self.canAccessCaseModule = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_lien_list') {
                                        self.canAccessLienModule = true;
                                    }
                                    if (self.permissions[i].name == 'can_see_resale_list') {
                                        self.canAccessResaleModule = true;
                                    }
                                    if (self.permissions[i].name == 'can_upload_customer_documents') {
                                        self.canUploadDocuments = true;
                                    }
                                    if (self.permissions[i].name == 'can_add_credit_card') {
                                        self.canAddCard = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        $(".removeActive").removeClass('active');
                        $("#menucustomers").addClass('active');
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            loadCustomer() {

                var path = window.location.pathname;
                var segments = path.split("/");
                //console.log(segments[3]);
                var self = this;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/getcustomers/" + segments[3],
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        //console.log(data[0]);
                        self.customerArr = data.content;
                        self.user_id = {value: data.content[0].user_id, text: data.content[0].user_first_name + " " + data.content[0].user_last_name/* + " - " + data.content[0].user_email*/}
                        /*self.dunningNotice = {value: data.content[0].dunning_notice, text: self.formatString(data.content[0].dunning_notice)}*/
                        self.dunningNotice = data.content[0].dunning_notice;
                        // self.user_id = {value : self.customerArr.user_id, text : self.customerArr.user_first_name };
                        // console.log(self.user_id);
                        self.cus_id = data.content[0].cusid;
                        self.resalePage.pt_tax_id = data.content[0].pt_tax_id;
                        self.resalePage.sv_tax_id = data.content[0].sv_tax_id;
                        if(data.content[0].doc_paths != null){
                            self.dropZonePreviewFiles = data.content[0].doc_paths;
                            self.countFiles = data.content[0].doc_paths.length;
                        }
                        self.cardDetailArr = data.content[0].cardDetailsArr;
                        if (data.content[0].cardDetailsArr[0] != undefined){
                            self.credit_card = data.content[0].cardDetailsArr[0];
                        }
                        self.carb_card = data.content[0].carb_card_number;
                        self.carb_card_expiry = data.content[0].carb_card_expiry;
                        if (data.content[0].carb_card_number != null){
                            self.is_carb_add = false;
                            self.has_carb_card = true;
                        }

                        self.loadCases();
                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },
            backShowCustomer() {
                var self = this;
                self.$router.push('/listcustomer');

            },
            userChangedValue: function (value) {

                //console.log("", value);
            },
            onSearchUser(search, loading) {
                if (search.length > 1) {
                    loading(true);
                    this.loadUser(loading, search, this);
                }
            },
            loadUser(loading, search, vm) {

                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get/users",
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search,
                        type: 'collector',
                    },
                    dataType: 'json',
                    success: function (data) {
                        loading(false);

                        self.usersArr = data;

                        //console.log(self.usersArr);
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                })

            },
            updateCollector() {
                this.$validator.validate().then(result => {
                    if (result) {
                        var self = this;
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        //console.log(self.user_id.value);
                        //console.log(segments[3]);
                        self.showLoader();

                        // var fields = $('#collector').serializeArray();
                        // fields.push({name: 'user_id', value: self.user_id.value});


                        $.ajax({
                            url: process.env.ROOT_API + "/update/collector/" + segments[3],
                            type: "POST",
                            data: {user_id: self.user_id.value, dunningNotice: self.dunningNotice, custId: segments[3]},
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: 'json',
                            success: function (data) {
                                self.hideLoader();
                                //console.log(data);
                                
                                $(".alert-success").html(data.message);
                                $(".alert-success").parent().removeClass('hide');
                                $(".alert-success").parent().addClass('show');
                                setTimeout(function () {
                                    $('.alert-success').parent().removeClass('show');
                                    $('.alert-success').parent().addClass('hide');
                                }, 5000);
                                if (data.status == 'success') {
                                    //console.log(data.content);


                                } else {
                                    if (data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < data.content.length; i++) {
                                            err += data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").parent().removeClass('hide');
                                        $(".alert-danger").parent().addClass('show');
                                        setTimeout(function () {
                                            $('.alert-danger').parent().removeClass('show');
                                            $('.alert-danger').parent().addClass('hide');
                                        }, 5000);
                                    }
                                }

                                //show dunning notice status in real time without calling any API
                                self.customerArr[0].dunning_notice = self.dunningNotice;
                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                if (jqXHR.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem('user_obj');
                                        localStorage.removeItem('api_token');
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }
                                    $("#errorMsg").html(jqXHR.responseJSON.message);
                                    $(".alert-danger").parent().removeClass('hide');
                                    $(".alert-danger").parent().addClass('show');
                                    setTimeout(function () {
                                        $('.alert-danger').parent().removeClass('show');
                                        $('.alert-danger').parent().addClass('hide');
                                    }, 5000);
                                }
                            }
                        });

                    }
                });
            },
            formatString(data) {
                var self = this;
                if (typeof (data) != 'undefined') {
                    var value = data.replace(/_/g, " ");
                    var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                        return letter.toUpperCase();
                    });
                    return upp;
                } else {
                    return false;
                }
            },
            formatDate(date) {
                if (typeof (date) != 'undefined') {
                    date = date.split(" ");
                    date = date[0];
                    var d = new Date(date);
                    var month = '' + (d.getMonth() + 1);
                    var day = '' + d.getDate();
                    var year = d.getFullYear();
                    if (month.length < 2)
                        month = '0' + month;
                    if (day.length < 2)
                        day = '0' + day;
                    return [month, day, year].join('/');
                } else {
                    return false;
                }
            },
            mobilenumber(string, position, addstring) {
                if ($.trim(string) === "" && $.trim(string).length <= 0) {
                    return string;
                } else {
                    return [string.slice(0, position), addstring, string.slice(position)].join('');
                }
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            allClickCase: function () {
                var self = this;
                self.messageCase = 'all';
                self.loadCases();
            },
            myClickCase: function () {
                var self = this;
                self.messageCase = 'my';
                self.loadCases();
            },
            loadCases: function () {
                var self = this;

                var fields = {
                    page: self.serverParamsCase.page,
                    perPage: self.serverParamsCase.perPage,
                    filters: self.serverParamsCase.columnFilters,
                    messageData: self.messageCase,
                    sort: self.serverParamsCase.sort,
                    exportFiltered: self.exportFilteredFlag,
                    cusid: self.cus_id
                };

                this.firstLoad = 1;
                // console.log(self.serverParamsCase.perPage);
                $.ajax({
                    url: process.env.ROOT_API + "/case/list",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        self.exportFilteredFlag = false;
                        if (data.message == 'success' || data.message == 'error') {
                            self.rowsCase = data.content.row;
                            self.totalRecordsCase = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                        if (data.message == "success export") {
                            //console.log(data.content.web);
                            $('#exportCase').html('<i class="fa fa-cloud-download" aria-hidden="true"></i>');
                            $('#exportCase').prop("disabled", false);
                            location.href = data.content.web;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }


                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            updateParamsCase(newProps) {
                this.serverParamsCase = Object.assign({}, this.serverParamsCase, newProps);
            },
            //
            onPageChangeCase(params) {
                this.updateParamsCase({page: params.currentPage});

                this.loadCases();
            },
            //
            onPerPageChangeCase(params) {
                this.updateParamsCase({perPage: params.currentPerPage});
                this.totalRecordsCase = self.totalRecordsCase;
                this.loadCases();
            },

            onColumnFilterCase(params) {
                this.updateParamsCase(params);

                {
                    field: ('id');
                    field: ('collector_user_full_name');
                    field: ('assigned_internal_user');
                    field:('status');
                    field:('priority');
                    field:('cusid');
                    field:('customer_firstname');
                    field:('created_at');
                }
                ;
                this.serverParamsCase.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParamsCase));
                var filters = filtersPr.columnFilters;

                if (this.firstLoad == 1 || filters.id || filters.collector_user_full_name || filters.assigned_internal_user
                        || filters.status || filters.priority || filters.cusid || filters.customer_firstname || filters.created_at) {
                    this.loadCases();
                }

            },
            selectionChangedCase() {

                var self = this;
                // console.log( this.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            onSortChangeCase(params) {
                this.updateParamsCase({
                    sort: {
                        type: params.sortType,
                        field: this.columnsCase[params.columnIndex].field,
                        /*type: params[0].type,
                         field: params[0].field,*/
                    },
                });
                this.loadCases();
            },
            formatAmount(amt) {
                amt += '';
                var x = amt.split('.');
                var x1 = x[0];
                var x2 = x.length > 1 ? '.' + x[1] : '.' + '00';
                if (x2.length == 2) {
                    x2 = x2 + "0";
                }
                var rgx = /(\d+)(\d{3})/;
                while (rgx.test(x1)) {
                    x1 = x1.replace(rgx, '$1' + ',' + '$2');
                }
                return process.env.CURRENCY_SYMBOL + x1 + x2;
            },
            uploadDocs() {
                var self = this;
                self.fileErrorMsg = '';
                if(self.files.length === 0){
                    self.fileErrorMsg = "Please select at lease one document to upload.";
                    return;
                }
                var path = window.location.pathname;
                var segments = path.split("/");
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/store-customer-docs",
                    type: "POST",
                    data: {
                        custId: segments[3],
                        files: self.files
                    },
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.removeFileFlag = true;
                        self.hideLoader();
                        self.dropZonePreviewFiles = [];
                        self.dropZonePreviewFiles = data.content;
                        self.countFiles = data.content.length;
                        self.files = [];
                        self.$refs.documentDropzone.removeAllFiles();
                        setTimeout(() => {
                            self.removeFileFlag = false;
                        }, 1000);
                        Swal.fire(
                            'Uploaded!',
                            'Your files has been succefully uploaded.',
                            'success'
                        )
                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },
            goToGenerateFilePath(path, flag){
                var self = this;
                self.generateFilePath(path, flag, 0);
            },
            checkFileSize(file) {
                var self = this;
                self.fileErrorMsg = "";
                if(file.size >= 26214400){
                    self.fileErrorMsg = "The file size is too large. Please upload a file smaller than 25MB.";
                    self.$refs.documentDropzone.removeFile(file);
                    return;
                }
            },
            storeDocument(file, response) {
                var self = this;
                var uploadResponse = response.content;

                if (self.files.length > 0) {
                    var idx = self.files.findIndex((obj) => obj == uploadResponse);
                    if (idx == -1) {
                        self.files.push(uploadResponse);
                    }
                } else {
                    self.files.push(uploadResponse);
                }

                if (file.type != undefined) {
                    var extension = file.type.split("/");
                }
            },
            removedSelectedFile(file, xhr, error) {
                var self = this;
                if(!self.removeFileFlag){
                    var orderId = "";
                    if (file.status !== "error" && file.xhr) {
                        const fileName = JSON.parse(file.xhr.response).content;
                        const fileArr = fileName.split("/");

                        self.removeFileFromTemp(fileArr[1], orderId)
                            .then(() => {
                                const index = self.files.findIndex(f => f.includes(fileName));
                                if (index !== -1) {
                                    self.files.splice(index, 1);
                                }
                            })
                            .catch(error => {
                                console.error("Error removing file from server:", error);
                            })
                            .finally(() => {
                                self.loading = false;
                            });
                    }
                }
            },
            removeFileFromServer(fileName, key, filePath) {
                var self = this;
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {                
                        self.showLoader();
                        self.dropZonePreviewFiles.splice(key, 1);

                        //remove file from files array
                        for (var i = 0; i < self.files.length; i++) {
                            if (self.files[i].includes(fileName)) {
                                self.files.splice(i, 1);
                            }
                        }

                        var path = window.location.pathname;
                        var segments = path.split("/");
                        $.ajax({
                            url: process.env.ROOT_API + "/remove-file-from-server",
                            type: "GET",
                            data: {
                                id: segments[3],
                                filePath: filePath,
                                flag: 'customer'
                            },
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: 'json',
                            success: function (data) {
                                self.hideLoader();
                                if (data.code == 200) {
                                   Swal.fire(
                                        'Deleted!',
                                        'Your file has been deleted.',
                                        'success'
                                    )
                                    self.dropZonePreviewFiles = [];
                                    self.dropZonePreviewFiles = data.content;
                                    self.countFiles = data.content.length;
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                if (jqXHR.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem('user_obj');
                                        localStorage.removeItem('api_token');
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }
                                    self.error = jqXHR.responseJSON.message;
                                }
                            }

                        });
                    }
                })
            },
            removeFileFromTemp(file) {
                var self = this;
                self.showLoader();
                return new Promise((resolve, reject) => {
                    $.ajax({
                        url: process.env.ROOT_API + "/remove-temp-files",
                        type: "POST",
                        data: {
                            filePath: file,
                        },
                        headers: {
                            'Accept': 'application/json',
                            "Access-Control-Allow-Origin": '*',
                            "Authorization": "Bearer " + localStorage.getItem("api_token"),
                            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                            "Cache-Control": "no-cache"
                        },
                        dataType: "json",
                        success: data => {
                            resolve(data);
                            self.hideLoader();
                        },
                        error: (jqXHR, textStatus, errorThrown) => {
                            self.hideLoader();
                            reject(errorThrown);
                        }
                    });
                });
            },
            downloadAllFiles(){
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                const filePaths = self.dropZonePreviewFiles.map(file => file.filePath);
                self.generateFilePath(filePaths, 'multipleCustomer', segments[3]);
            },
            navigateLien() {
                // Find the element with the highlighted class
                const highlightedElement = this.$el.querySelector('.lien-mod-class');
                console.log(highlightedElement)
                if (highlightedElement) {
                    highlightedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            },

            addCustomerCard: function(){
                var self = this;

                self.$router.push("/customer-card/create/"+self.$route.params.id);
            },
            maskCardNumber(cardNumber) {
                if (!cardNumber) return '';
                    return '*'.repeat(14 - 4) + cardNumber;
            },

            addProcessDate(processDate,id){
                var self = this;
               
                processDate = processDate.value == undefined ? processDate[0] : processDate.value;
                if (processDate == '' || processDate == undefined){
                    alert('Please select process day');
                    return;
                }
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/update-process-date",
                    type: "POST",
                    data: {
                        date: processDate,
                        id:id
                    },
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: "json",
                    success: data => {
                        self.hideLoader();
                    },
                    error: (jqXHR, textStatus, errorThrown) => {
                        self.hideLoader();
                    }
                });
            },
            addCarbCard: function(){
                var self = this;
                self.is_carb_add = true;
                self.has_carb_card = true;
            },
            cancelCarbCard: function(){
                var self = this;
                self.has_carb_card = false;
                if (self.carb_card != null && self.carb_card != ''){
                    self.is_carb_add = false;
                    self.has_carb_card = true;
                }
            },
            saveCarbCard: function(){
                var self = this;
                this.$validator.validate().then(result => {
                    if (result) {
                        self.showLoader();
                        $.ajax({
                            url: process.env.ROOT_API + "/carb_card/create",
                            type: "POST",
                            data: {
                                card: self.carb_card,
                                expiry_date: self.carb_card_expiry,
                                cus_id: self.$route.params.id
                            },
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: "json",
                            success: data => {
                                self.hideLoader();
                                self.is_carb_add = false;
                            },
                            error: (jqXHR, textStatus, errorThrown) => {
                                self.hideLoader();
                            }
                        });
                    }
                });
            },
        },
    }
</script>
<style scoped>
.field-error{
    color: #cf0010;
    font-size: 14px;
    display: block;
    line-height: 14px;
}
.attachment-list {
    padding: 5px;
    background-color: #f2f2f2;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.dropzone-previews i{
    font-size: 14px;
    color: gray;
    margin-right: 5px;
}
.red-box {
    border: 2px solid red;
    background-color: #f8d7da;
    color: #721c24;
    padding: 5px;
    margin-left: 60%;
    margin-top: 5px;
    border-radius: 5px;
    font-family: Arial, sans-serif;
    width: 25%;
    margin-right: auto;
}
.custom-class-margin{
    margin-top: -40px;
}
.bgChange {
    color: rgb(223, 150, 150) !important;
    background: rgb(223, 172, 172) !important;
    border-bottom: 2px solid #f5f5f5 !important;
}
.lien-mod-class {
  overflow-y: auto; /* Enable scrolling */
  display: inline;
}
.no-style {
  color: inherit; /* Removes default blue color */
  text-decoration: none; /* Removes underline */
}
.redzone {
  background-color: rgb(234, 134, 134); /* Example style; replace with your actual styling */
}
.pull-right{
    float: right;
}
.v-select-option {
  padding: 10px;
  border: 1px solid #ddd;
}

.highlighted {
  background-color: rgb(222, 117, 117);
  /* color: white; Optional: change text color for better readability */
}
.custom-margin{
    margin-top: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/customer/CustomerView.vue